import React from 'react';
// @ts-ignore
import Form from '../../../gd-form/form/form-modal-new/form-modal-new.tsx';
// @ts-ignore
import FormError from '../../../gd-form/common/form-error/form-error.tsx';
import FormManager from '../../../gd-form/common/form-manager';
import Input from '../../../gd-form/form-element/input/input';
// @ts-ignore
import SelectIcon from '../../../gd-ui/select-icon/select-icon.jsx';
// @ts-ignore
import Textarea from "src/core/gd-form/form-element/textarea/textarea";

type Props = {
    noteType: any
    onSubmit: callback
}

export default class ModalDocument_NewDocumentType extends React.Component<Props> {

    public form: any

    constructor(props: Props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        const { noteType } = this.props;

        const initFormData = {
            name: noteType ? noteType.name : '',
            icon: noteType ? noteType.icon : gd.const.note.defaultIcon
        };

        const formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true,
                    label: 'Name'
                },
                icon: {
                    type: 'select',
                    isRequired: true,
                    label: 'Icon'
                },
                description: {
                    type: 'input',
                    isRequired: true
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result: any)=> {
        this.props.onSubmit(result);
    }

    renderIcon() {
        return (
            <div className="row">
                <div className="label">Icon</div>
                <div className="element">
                    <SelectIcon iconType="note" renderValue="form" form={this.form} name="icon" />
                    <FormError form={this.form} name="icon" />
                </div>
            </div>
        );
    }

    render() {
        return (
            <Form form={this.form} >
                <div className="tbl">
                    <div className="row ">
                        <div className="label">Name</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name"/>
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>
                    {this.renderIcon()}

                    <div className="row">
                        <div className="label">Description</div>
                        <div className="element">
                            <Textarea className="textarea-three-rows note-description"
                                      size="big"
                                      rows={2}
                                      form={this.form}
                                      name="description" />

                            <FormError form={this.form} name="description" />
                        </div>

                    </div>
                </div>
            </Form>
        );
    }
}